import AbstractId from "../all/AbstractId";
import logger from 'src/utils/logger/logger';

class Web0sId extends AbstractId {
    constructor() {
        super();
    }

    getDeviceType() {
        return "TV";
    }

    getHardwareType() {
        return this.HARDWARE_TYPE.TV;
    }

    getFirmware() {
        //to get the browser and version
        var name = "web0s",
            version = "DummyFirmware",
            ua = navigator.userAgent.toLowerCase();
        try {
            if (ua.indexOf("chrome") !== -1) {
                name = "Chrome";
                version = (/chrome\/([\d.]+)/.exec(ua))[1];
            } else if (ua.indexOf("firefox") !== -1) {
                name = "Firefox";
                version = (/firefox\/([\d.]+)/.exec(ua))[1];
            } else if (ua.indexOf("opera") !== -1) {
                name = "opera";
                version = (/version\/([\d.]+)/.exec(ua))[1];
            } else if (ua.indexOf("safari") !== -1) {
                name = "safari";
                version = (/version\/([\d.]+)/.exec(ua))[1];
            }
        } catch (ex) {
            logger.warn("unable to determine the firmware");
        }
        return name + "/" + version;
    }

    getSDKVersion(__callback) {
      const webOS = window.webOS;

      if (!webOS) {
        __callback(null);
        return;
      }

      if (!webOS.service) {
        __callback(null);
        return;
      }

      const sdkRequest = webOS.service.request('luna://com.webos.service.tv.systemproperty', {
        method: 'getSystemInfo',
        parameters: {
          keys: ['sdkVersion']
        },

        onComplete: function(sysResponse) {
          const isSucceeded = sysResponse.returnValue;
          if (isSucceeded) {
            let sdkv = null;
            if (sysResponse.sdkVersion) {
              sdkv = sysResponse.sdkVersion.split('.');
              if (sdkv[0]) {
                if (!isNaN(sdkv[0])) {
                  sdkv = parseInt(sdkv[0]);
                }
              }
            }
            __callback(sdkv);
          } else {
            logger.debug('Web0sId > getSDKVersion Failed to get TV SDK version information');
            __callback(null);
          }

          return;
        }
      });
    }
}

export default Web0sId;



// WEBPACK FOOTER //
// ./src/devices/web0s/Id.js